import { DefaultDropdownLayoutProps, Option } from 'framework/form';
import { CSSObjectWithLabel, StylesConfig } from 'react-select';
import { Theme } from '@mui/material/styles';

const getDropdownLayoutCommonProps = (props: DefaultDropdownLayoutProps<any[]>, theme: Theme) => {
  const { errorMessages } = props;

  const hasError = errorMessages && errorMessages.length > 0;
  const invalidClass = hasError ? 'is-invalid' : '';
  const selectClassName = `dropdown-container ${invalidClass}`;
  const classNamePrefix = 'dropdown';

  const isFinanceAccountDropdown = props.className?.includes('finance-account-dropdown');
  const styles = {
    menu: (base: CSSObjectWithLabel) => ({ ...base, zIndex: 10, boxShadow: theme.shadows[2] }),
    menuList: (base: CSSObjectWithLabel) => ({
      ...base,
      backgroundColor: theme.palette.background.primary || theme.palette.background.paper,
    }),
    menuPortal: (base: CSSObjectWithLabel) => ({ ...base, zIndex: 1400 }),
    option: (base: CSSObjectWithLabel, state: any) => ({
      ...base,
      padding: '5px 12px',
      color: state.isDisabled && isFinanceAccountDropdown ? theme.palette.text.secondary : theme.palette.text.primary,
      backgroundColor: state.isSelected
        ? theme.palette.background.primary || theme.palette.background.paper
        : state.isFocused
          ? theme.palette.common.menuItemActive
          : 'transparent',
      opacity: state.isDisabled && !isFinanceAccountDropdown ? 0.5 : 1,
      cursor: state.isDisabled && isFinanceAccountDropdown ? 'default' : base.cursor,
      ':hover': { backgroundColor: theme.palette.common.menuItemActive },
    }),
    control: (base: CSSObjectWithLabel, state: any) => ({
      ...base,
      padding: '4px 10px',
      background: state.isDisabled ? theme.palette.common.inputDisabledBackground : 'inherit',
      outline: 'none',
      boxShadow: 'none',
      border: 'none',
      borderColor: hasError
        ? theme.palette.error.main
        : state.isFocused
          ? theme.palette.primary.main
          : base.borderColor,
      cursor: state.isDisabled ? 'not-allowed' : base.cursor,
      opacity: state.isDisabled ? 0.38 : 1,
      transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
      ':hover': {
        borderColor: hasError ? theme.palette.error.main : theme.palette.neutral?.main || theme.palette.divider,
        '.dropdown__clear-indicator': { opacity: 1 },
      },
      '.dropdown__placeholder': { opacity: state.isFocused ? 1 : undefined },
      '.dropdown__indicator': { transform: state.menuIsOpen ? 'rotate(180deg)' : undefined },
    }),
    valueContainer: (base: CSSObjectWithLabel) => ({ ...base, padding: '0 4px 0 1px', minHeight: '2em' }),
    singleValue: (base: CSSObjectWithLabel, state: any) => ({
      ...base,
      margin: 0,
      color: state.isDisabled ? theme.palette.text.disabled : base.color,
    }),
    input: (base: CSSObjectWithLabel) => ({ ...base, transform: 'translateX(-2px)' }),
    multiValue: (base: CSSObjectWithLabel) => ({ ...base, marginTop: '3px' }),
    noOptionsMessage: (base: CSSObjectWithLabel) => ({ ...base, color: theme.palette.text.secondary }),
  } as StylesConfig<string | Option, false>;

  return {
    hasError,
    invalidClass,
    selectClassName,
    styles,
    classNamePrefix,
  };
};

export default getDropdownLayoutCommonProps;
